import { render, staticRenderFns } from "./ConsultingSettingsListView.vue?vue&type=template&id=3953b0c5"
import script from "./ConsultingSettingsListView.vue?vue&type=script&lang=js"
export * from "./ConsultingSettingsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports